export default "__VITE_ASSET__eQHgIMxg__"